import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "./Store/slices/cartSlice";
import AppLayout from "./app/layout/AppLayout";
import { message } from "antd";
import AppRoutes from "./app/routes/AppRoutes";

const Home = () => {
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart.items);
  const handleClick = (item) => {
    dispatch(addToCart(item));
    message.success("Add to Cart");
  };
  return (
    <AppLayout cartCount={cart.length}>
      <AppRoutes cart={cart} handleClick={handleClick} />
    </AppLayout>
  );
};

export default Home;
